module.exports = __webpack_public_path__ + "img/Asset 82.12669062.svg";